import imguser from '../../../../assets/images/user.png'
import stats from '../../../../assets/images/stats.png'
import subscribers from '../../../../assets/images/multiple-users-silhouette.png'
import moment from 'moment';
import Switch from "react-switch";

export const ColumnVCards = (translate, warning, handleEdit, langLocal) => {
    const columns = [
        {
            name: <span className="color_spann">{translate('id')}</span>, sortable: true, width: "50px",
            cell: (row) => (
                <span>{row['id']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('vcard_name')}</span>, sortable: true, width: "180px",
            cell: (row) => (
                <div className='div_img_table' >
                    <img className={langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} src={row?.img} />
                    <span>{row['name']}</span>
                </div>
            )
        },
        {
            name: <span className="color_spann">{translate('preview_url')}</span>, sortable: true, width: "250px",
            cell: (row) => (
                <span><a href={row?.url} target="_blank" >{row['url']}</a></span>
            )
        },
        {
            name: <span className="color_spann">{translate('stats')}</span>, width: "220px", width: "130px",
            cell: (row) => (
                <img style={langLocal === "en"? {marginLeft: "10px"}:{marginRight: "10px"}} 
                className={`stats-icon ${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"}`} src={stats} />
            )
        },
        {
            name: <span className="color_spann">{translate('subscribers')}</span>, width: "150px",
            cell: (row) => (
                <div className='div-stats-icon' >
                    <img style={langLocal === "en"?  {marginRight: "40px"}:{marginRight: "-60px"}}
                     className={`stats-icon ${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"}`} src={subscribers} />
                </div>
            )
        },
        {
            name: <span className="color_spann">{translate('status')}</span>, width: "100px",
            cell: (row) => (
                <div className='div_switch'>
                    <SwitchComponent checked={row.status} /*onChange={() => editStatus(row.id, row.status)}*/ />
                </div>
            )
        },
        {
            name: <span className="color_spann">{translate('created_at')}</span>, width: "170px",
            cell: (row) => (
                <div className='div-created-at' >{moment(row['created_at']).format("YYYY-MM-DD")}</div>
            )
        },

        {
            name: <span className="color_spann">{translate('actions')}</span>,
            cell: (row) => (
                <div>
                    <i className='fa fa-edit icon_edit' onClick={(e) => handleEdit(e, row)} ></i>
                    <i className='fa fa-trash icon_trash' onClick={() => warning(row)} ></i>
                </div>
            )
        }
    ]
    return {
        columns
    }
}
function SwitchComponent({ checked, onChange }) {
    return (
        <Switch
            onColor='#756bc1'
            checkedIcon={false}
            uncheckedIcon={false}
            height={20}
            width={40}
            handleDiameter={15}
            checked={checked}
            onChange={onChange}
        />
    );
}
{/*<OptionsIcon warning={warning} row={row} setopenEdit={setopenEdit} handleEdit={handleEdit} />*/ }

